var React = require('react');

function ArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.9947 7.85104L9.42492 4.06094C9.37961 4.02187 9.32179 4 9.26086 4H7.87804C7.76242 4 7.70929 4.14375 7.79679 4.21875L11.9353 7.63542H1.45825C1.3895 7.63542 1.33325 7.69167 1.33325 7.76042V8.69792C1.33325 8.76667 1.3895 8.82292 1.45825 8.82292H11.9338L7.79523 12.2396C7.70773 12.3161 7.76086 12.4583 7.87648 12.4583H9.30617C9.33586 12.4583 9.36554 12.4474 9.38742 12.4271L13.9947 8.60729C14.0488 8.56025 14.0922 8.50216 14.1219 8.43693C14.1516 8.3717 14.167 8.30085 14.167 8.22917C14.167 8.15748 14.1516 8.08664 14.1219 8.0214C14.0922 7.95617 14.0488 7.89808 13.9947 7.85104Z","fill":"#BC9F5F"}));
}

ArrowIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = ArrowIcon;

ArrowIcon.default = ArrowIcon;
